<template>
  <div class="wrapper">
    <div class="header-section">
      <h5>Zwroty</h5>
    </div>
    <div class="text-section">
      <p>
        1. Podstawą przyjęcia reklamacji jest przedstawienie przez Klienta dowodu zakupu towaru (paragon fiskalny lub faktura VAT).<br>
        2. W przypadku niezgodności towaru z umową Klient powinien odesłać do Sklepu reklamowany towar wraz z opisem niezgodności. <br>
        3. Sklep ustosunkowuje się do reklamacji Klienta w terminie 14 dni roboczych od momentu zwrotu towaru wraz z opisem niezgodności.
        W przypadku, gdy weryfikacja niezgodności wymaga zasięgnięcia opinii biegłego,
        bądź przedstawiciela producenta towaru, termin do ustosunkowania się Sklepu ulega przedłużeniu
        o czas uzyskania przez Sklep takiej opinii. <br>
        4. Gdy realizacja uzasadnionej reklamacji wiąże się z wysłaniem Klientowi nowego towaru
        bądź usunięcia niezgodności, koszty dostaw ponosi Sklep. <br>
        5. Indywidualne ustawienia komputera i monitora Klienta powodujące błędne
        lub zniekształcone wyświetlanie informacji o towarach (np. kolorów), nie mogą być podstawą reklamacji <br>
      </p>
    </div>
    <div class="header-section">
      <h5>Prawo odstąpienia od umowy</h5>
    </div>
    <div class="text-section">
      <p>
        1. Na podstawie Ustawy o ochronie niektórych praw konsumentów oraz o odpowiedzialności
        za szkodę wyrządzoną przez produkt niebezpieczny z dnia 2 marca 2000 r. Klient ma prawo
        odstąpienia od umowy. <br>
        2. Prawo odstąpienia od umowy jest skuteczne jeżeli Klient złoży Sklepowi,
        w terminie 10 dni od odbioru towaru, oświadczenie o odstąpieniu od umowy. <br>
        3. Klient zwraca towar do Sklepu w terminie 14 dni od złożenia oświadczenia o
        odstąpieniu od umowy. Zwrócony towar powinien być w stanie nienaruszonym,
        w tym powinien być kompletny, w fabrycznym opakowaniu (musi posiadać oryginalne metki),
        nie może nosić śladów eksploatacji. Koszty przesyłki ponosi Klient. <br>
        4. W ciągu 3 dni roboczych od otrzymania przesyłki, Sklep sprawdzi stan przekazanego produktu. <br>
        5. W terminie 7 dni od sprawdzenia towaru Sklep zwraca Klientowi zapłaconą kwotę,
        pomniejszoną o koszty realizacji zamówienia. Klient powinien wskazać numer rachunku bankowego,
        na jaki ma zostać przelana zwracana kwota. W przypadku płatności kartą płatniczą
        zwrot środków zostanie wykonany na kartę. <br>
        6. W przypadku naruszenia przez Klienta warunków określonych w ust 2 i 3
        powyżej oświadczenie o odstąpieniu od umowy jest bezskuteczne, towar nie podlega zwrotowi,
        a Sklep nie zwraca Klientowi zapłaconej kwoty. <br>
        7. Prawo odstąpienia nie przysługuje Klientowi w przypadkach określonych w
        art. 10 ust. 3 ustawy określonej w ust. 1 powyżej, tj. w zakresie: <br>
        a) świadczenia usług rozpoczętych, za zgodą Klienta, przed upływem terminu
        odstąpienia od umowy (dotyczy przypadków świadczenia usług, a nie sprzedaży towarów), <br>
        b) nagrań audialnych i wizualnych oraz zapisanych na informatycznych nośnikach danych
        po usunięciu przez Klienta ich oryginalnego opakowania, <br>
        c) umów dotyczących świadczeń, za które cena lub wynagrodzenie zależy wyłącznie
        od ruchu cen na rynku finansowym, <br>
        d) świadczeń o właściwościach określonych przez Klienta w złożonym przez niego
        zamówieniu lub ściśle związanych z jego osobą, <br>
        e) świadczeń, które z uwagi na ich charakter nie mogą zostać zwrócone lub których
        przedmiot ulega szybkiemu zepsuciu, <br>
        f) dostarczania prasy, <br>
        g) usług w zakresie gier hazardowych. <br>
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Returns'
}
</script>

<style scoped lang="scss">
.wrapper {
  height: 100%;
  width: 100%;
  padding: 10px;
  padding-top: 80px;
  color: #000000;
}
.header-section {
  margin-bottom: 20px;
  margin-top: 70px;
  letter-spacing: 3px;
  font-weight: bold;
}

.text-section {
  text-align: justify;
  margin-bottom: 30px;
}
.image-section {
  margin-bottom: 100px;
  margin-top: 50px;
}
.image-section img {
  width: 100%;
}

@media (min-width: 992px) {
  .wrapper {
    padding-top: 20px;
    width: 96%;
    margin-right: auto;
    margin-left: auto;
  }
  .text-section {
    font-size: 1.2rem;
    letter-spacing: 1.5px;
    margin-bottom: 30px;
  }
  .header-section {
    margin-bottom: 80px;
    letter-spacing: 4px;
  }
  .header-section h5 {
    font-size: 2rem;
  }
  .image-section {
    margin-top: 90px;
    margin-bottom: 140px;
  }
}
</style>
